/**
 * @param num
 * @param {boolean} isToEnglish
 * @return {string}
 */
export function number(num, isToEnglish = false) {
    num = num + "";//make sure that number will be converted to string;
    isToEnglish = isToEnglish || !Salla.config.get('store.settings.arabic_numbers_enabled');
    let ar = ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'];
    let en = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
    let find = isToEnglish ? ar : en;
    let replace = isToEnglish ? en : ar;
    let regex;
    for (let i = 0; i < find.length; i++) {
        regex = new RegExp(find[i], "g");
        num = num.replace(regex, replace[i]);
    }
    //todo:: replace dots between two digits only, to avoid replacing the period
    return num.replace(isToEnglish ? '٫' : '.', isToEnglish ? '.' : '٫');
}

/**
 * when need to get digit's only from string "Jamal12Hi" => 12, or "١٢٣" => 123
 * @param {string} num
 * @return {string}
 */
export function digitsOnly(num) {
    return number(num, true).replace(/[^0-9.]/g, '')
        .replace('..', '.')
        .rtrim('.'); // without this: `Salla.helpers.digitsOnly('١٬٦٠٠ ر.س')` => `1600.`
}

/**
 * @param {HTMLInputElement|string} input - selector or input object
 * @param {boolean} is_decimal
 * @return {string|*|void}
 */
export function inputDigitsOnly(input, is_decimal = false) {
    if (typeof input == 'string') {
        return document.querySelectorAll(input).forEach(el => inputDigitsOnly(el, is_decimal));
    }
    if (!input) {
        Salla.logger.warn('Can\'t find Object With Id: ' + input);
        return;
    }
    let new_val = Salla.helpers.digitsOnly(input.value);

    if (input.min && new_val < parseInt(input.min)) {
        return input.value = input.min;
    }
    if (input.max && new_val > parseInt(input.max)) {
        return input.value = input.max;
    }
    if (input.maxLength >= 1 && new_val.toString().length > input.maxLength) {
        return input.value = new_val.toString().substring(0, input.maxLength);
    }

    return input.value = (is_decimal || input.dataset.hasOwnProperty('digitsWithDecimal'))
        ? getOnlyDecimal(new_val)
        : new_val.replace(/\D/g, '');
}

export function getOnlyDecimal(value) {
    let dotsCount = (`${value}`.match(/\./g) || []).length;
    if (!dotsCount || dotsCount === 1) {
        return value;
    }

    // if there is more than one dotes, remove the last dot.
    // Ex: 123.545.66 => 123.54566
    return getOnlyDecimal(value.replace(/\.(.+)\./g, '.$1'));
}

/**
 * @param {string|number|{amount: number,currency: string}} money
 * @return string
 */
export function money(money, useSarSymbolIfEnabled = true) {
    let currency = Salla.config.currency(money?.currency).symbol;
    money = typeof money === 'object' ? money.amount : money;
    money = number(money) + ' ' + currency;
    if(useSarSymbolIfEnabled && ['SAR', 'ر.س'].includes(currency) && Salla.config.get('store.settings.use_sar_symbol')){
        money = money.replace(currency, '<i class=sicon-sar></i>');
    }
    return money;
}